import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import styles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  id: null,
  value: ''
};

export default class NumberInput extends PureComponent {
  render () {
    const id = this.props.id || `${uniqueId('number-')}_${this.props.field.replace('.', '_')}`;
    const label = !this.props.label ? null : (
      <label htmlFor={id}>{this.props.label}</label>
    );
    const css = `${styles["text-input"]} ${this.props.required ? styles.required : ""} ${this.props.fullWidth ? styles["full-width"] : ""}`;
    const { field, onChange, value } = this.props;

    return (
      <div className={css}>
        {label}
        <input
          id={id}
          data-field={field}
          value={value}
          onChange={onChange} />
      </div>
    );
  }
}

NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;
